<!-- 身份证图片识别入口，支持选择大陆或香港身份证并向父表单返回识别结果。 -->
<template>
  <div class="idcard-ocr">
    <!-- 使用按钮提供键盘操作和可访问名称，点击后选择上传类型。 -->
    <button type="button" class="ocr-trigger" aria-label="上传身份证识别" title="上传身份证识别" @click="showTypeModal">
      <img src="@/static/images/camera.png" class="ocr-icon" alt="" />
    </button>

    <!-- 选择证件类型弹窗 -->
    <Modal v-model="typeModalVisible" title="选择上传类型" :mask-closable="false" width="400">
      <div class="type-list">
        <button type="button" class="type-item" @click="selectType(1)">
          <span>大陆身份证</span>
        </button>
        <button type="button" class="type-item" @click="selectType(2)">
          <span>香港身份证</span>
        </button>
      </div>
      <div slot="footer"></div>
    </Modal>

    <!-- 上传组件（隐藏，用于触发文件选择） -->
    <Upload :show-upload-list="false" :multiple="false" action="/" accept=".jpg,.png,.jpeg" :before-upload="handleUpload" ref="uploadRef" style="display:none">
    </Upload>
  </div>
</template>

<script>
import { uploadFile } from '@/api/httpList';
export default {
  data() {
    return {
      loading: '',
      typeModalVisible: false,
      selectedType: 1, // 1大陆身份证 2香港身份证
    };
  },
  methods: {
    showTypeModal() {
      this.typeModalVisible = true;
    },
    selectType(type) {
      this.selectedType = type;
      this.typeModalVisible = false;
      this.$nextTick(() => {
        this.$refs.uploadRef.$el.querySelector('input').click();
      });
    },
    handleUpload(file) {
      const reg = /\.(png|jpg|jpeg)$/;
      if (!reg.test(file.name.toLowerCase())) {
        this.$notice.error(`上传格式不正确，请上传图片格式文件`);
        return false;
      }
      let formData = new FormData();
      formData.append('file', file);
      this.$notice.showLoading();
      uploadFile(formData).then(async res => {
        await this.ocr(res.data[0]);
      }).finally(() => {
        window.setTimeout(() => {
          this.$notice.hideLoading();
        }, 300);
      })
      return false;
    },
    ocr(data) {
      var params = { url: data.path };
      if (this.selectedType == 2) {
        params.type = '2';
        params.isFace = true;
      } else {
        params.isFace = true;
      }
      return this.$http({
        url: '/buz/tools/ocr',
        type: 'POST',
        data: params
      }).then(res => {
        this.$emit('ok', {
          ...res.data,
          ...data,
          idcardType: this.selectedType
        });
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.idcard-ocr {
  line-height: 30px;
  cursor: pointer;
}
.ocr-trigger {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 30px;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
}
.ocr-trigger:focus-visible,
.type-item:focus-visible {
  outline: 2px solid #2d8cf0;
  outline-offset: -2px;
}
.ocr-icon {
  display: block;
  width: 20px;
}
.type-list {
  .type-item {
    display: block;
    width: 100%;
    padding: 16px 20px;
    border: 1px solid #dcdee2;
    border-radius: 4px;
    background: #fff;
    margin-bottom: 12px;
    cursor: pointer;
    text-align: center;
    font-family: inherit;
    font-size: 14px;
    color: #333;
    transition: all 0.2s;
    &:hover {
      border-color: #2d8cf0;
      color: #2d8cf0;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
